import {ConstantsParser} from "../../../ConstantsParser";

export class Primary {
  constructor() {
    this.name = 'Primary'
    this.content = {
      srcType: 'youtube',
      srcLink: null,
      src: null,
      autoplay: false,
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    let classes = (new ConstantsParser(this.classes())).parse().join(' ')
    return `<div>
      <img
        class="${classes}"
        src="/img/video-placeholder.jpg"
        alt="video placeholder"
      />
    </div>`;
  }

  classes() {
    return [
      {property: 'Width', value: 'WIDTH_AUTO'},
      {property: 'Rounded', value: 'ROUNDED_LG'},
    ]
  }

  styles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#00ff00'},
    ]
  }

  containerStyles() {
    return []
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes(),
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles(),
      },
      containerStyles: {
        desktop: this.containerStyles(),
        tablet: this.containerStyles(),
        phone: this.containerStyles(),
      },
    }
  }
}
